



























































































































































import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import PromotionChannelGroup from "./PromotionChannelGroup.vue";
import PromotionGroupRow from "./PromotionGroupRow.vue";
import PromotionConditionPriceRow from "./PromotionConditionPriceRow.vue";
import {
  PromotionGroupForm,
  PromotionItemGroupForm,
  PromotionConditionPriceForm
} from "../forms/PromotionCreateForm";

export default Vue.extend({
  components: {
    PromotionChannelGroup,
    PromotionGroupRow,
    PromotionConditionPriceRow
  },
  props: {
    value: {
      type: Object as () => PromotionGroupForm
    },
    channels: {
      type: Array
    },
    isLoading: {
      type: Boolean
    },
    isDisable: {
      type: Boolean
    },
    validations: {
      type: Object
    },
    state: {
      type: String
    }
  },
  computed: {
    ...proxyModel(
      "conditionType",
      "channelsSelected",
      "conditionItemGroups",
      "promotionItemGroups",
      "promotionConditionPrices",
      "deletedConditionItemGroupsId",
      "deletedPromotionItemGroupsId",
      "deletedPromotionConditonPricesId",
      "orderItemLimit",
      "orderItemLimitAmount",
      "orderLimit",
      "promotionHold"
    ),
    isConditionTypeProduct() {
      return (this as any).conditionType === "PRODUCT";
    },
    isConditionTypePrice() {
      return (this as any).conditionType === "PRICE";
    },
    orderLimitError() {
      return (this as any).validations.orderLimit.$error
        ? "จำกัดจำนวน is required or invalid"
        : "";
    },
    orderItemLimitAmountError() {
      return (this as any).validations.orderItemLimitAmount.$error
        ? "จำกัดจำนวนชิ้นของแถม is required or invalid"
        : "";
    },
    isDisableLimitItem() {
      if ((this as any).state == "CREATE" || (this as any).state == "UPDATE") {
        return !(this as any).orderItemLimit;
      } else {
        return (this as any).isDisable;
      }
    }
  },
  methods: {
    addConditionItemGroup() {
      (this as any).conditionItemGroups = [
        ...(this as any).conditionItemGroups,
        { items: [], deletedItemsId: [] }
      ];
    },
    updateConditionItemGroup(
      conditionItemGroup: PromotionItemGroupForm,
      index: number
    ) {
      (this as any).conditionItemGroups = (this as any).conditionItemGroups.map(
        (e: any, i: any) => {
          return i === index ? conditionItemGroup : e;
        }
      );
    },
    removeConditionItemGroup(index: number) {
      (this as any).conditionItemGroups = (this as any).conditionItemGroups.filter(
        (_: any, i: any) => {
          return i !== index;
        }
      );
    },
    addPromotionItemGroup() {
      (this as any).promotionItemGroups = [
        ...(this as any).promotionItemGroups,
        { items: [], deletedItemsId: [] }
      ];
    },
    updatePromotionItemGroup(
      promotionItemGroup: PromotionItemGroupForm,
      index: number
    ) {
      (this as any).promotionItemGroups = (this as any).promotionItemGroups.map(
        (e: any, i: any) => {
          return i === index ? promotionItemGroup : e;
        }
      );
    },
    removePromotionItemGroup(index: number) {
      (this as any).promotionItemGroups = (this as any).promotionItemGroups.filter(
        (_: any, i: any) => {
          return i !== index;
        }
      );
    },
    addPromotionConditionPrice() {
      (this as any).promotionConditionPrices = [
        ...(this as any).promotionConditionPrices,
        {
          price: 0,
          promotionItemGroups: [{ items: [], deletedItemsId: [] }],
          deletedPromotionGroupsId: []
        }
      ];
    },
    updatePromotionConditionPrice(
      promotionConditionPrice: PromotionConditionPriceForm,
      index: number
    ) {
      (this as any).promotionConditionPrices = (this as any).promotionConditionPrices.map(
        (e: any, i: any) => {
          return i === index ? promotionConditionPrice : e;
        }
      );
    },
    removePromotionConditionPrice(index: number) {
      (this as any).promotionConditionPrices = (this as any).promotionConditionPrices.filter(
        (_: any, i: any) => {
          return i !== index;
        }
      );
    },
    checkConditionItem() {
      this.$emit("checkConditionItem");
    },
    checkPromotionItem() {
      this.$emit("checkPromotionItem");
    },
    checkConditionPriceItem() {
      this.$emit("checkConditionPriceItem");
    },
    addRemoveConditionItemGroupId(id: number) {
      if (id) {
        (this as any).deletedConditionItemGroupsId.push(id);
      }
    },
    addRemovePromotionItemGroupId(id: number) {
      if (id) {
        (this as any).deletedPromotionItemGroupsId.push(id);
      }
    },
    addRemovePromotionConditionPricesId(id: number) {
      if (id) {
        (this as any).deletedPromotionConditonPricesId.push(id);
      }
    }
  }
});
